import * as React from "react";
import type { SVGProps } from "react";

interface InterceptionProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Interception = ({ cancelled = false, ...props }: InterceptionProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none">
      <path
        fill="#FFF"
        d="M12 .75a11.25 11.25 0 1 0 0 22.5 11.25 11.25 0 0 0 0-22.5"
      />
      <path
        fill="#000"
        d="M12 1.7a10.3 10.3 0 1 0 0 20.6 10.3 10.3 0 0 0 0-20.6M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18"
      />
      <path
        fill="#007BBD"
        d="M12 17.5c-.7 0-1.04-.35-1.04-1.06V7.36c0-.7.35-1.06 1.04-1.06.7 0 1.04.35 1.04 1.06v9.08c0 .7-.35 1.06-1.04 1.06"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Interception;
